export default "__VITE_PUBLIC_ASSET__dfd167e3__"